// extracted by css-extract-rspack-plugin
export default {"cls1":"RadarNavButton-cls1_y_O","cls2":"RadarNavButton-cls2_1oR RadarNavButton-cls1_y_O"};